module.exports = __webpack_public_path__ + "static/pattern-8ce4120b3f7d9444bca4014639bb095a.jpg";